export default __webpack_public_path__ + "static/media/File5.40ebeadd.pdf";